import React from 'react';
import ShareButtons from './ShareButtons';
const ArticleModal = ({ article, onClose, formatDate }) => {
  if (!article) return null;
  
  // Get image URL (API returns 'banner_image_url', NOT 'imageUrl')
  const imageUrl = article.banner_image_url 
    || (article.images && article.images[0]);  // images are strings, not objects

  // Get title (API returns 'title' field directly)
  const title = article.title;
  
  // Get summary (API returns 'summary' field directly)
  const summary = article.summary;
  
  // Get key takeaways (API returns 'key_takeaways' as array)
  const keyTakeaways = article.key_takeaways || [];

  // Get source name (API returns 'source_name', NOT 'sourceName')
  const sourceName = article.source_name;
  
  // Get original URL (API returns 'url' field)
  const originalUrl = article.url;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        
        <div className="modal-header">
          <span className="modal-source">{sourceName}</span>
          <span className="modal-date">{formatDate(article.scraped_at)}</span>
          {article.reading_time && (
            <span className="modal-reading-time">{article.reading_time} min read</span>
          )}
        </div>
        
        {imageUrl && (
          <div className="modal-images">
            <img 
              src={imageUrl} 
              alt={title}
              onError={(e) => e.target.style.display = 'none'} 
            />
          </div>
        )}
        
        <h1 className="modal-title">{title}</h1>
        
        {article.author && (
          <div className="modal-author">By {article.author}</div>
        )}
        
        <div className="modal-body">
          <div className="modal-summary">
            <h3>Summary</h3>
            <p>{summary}</p>
          </div>
          
          {keyTakeaways && keyTakeaways.length > 0 && (
            <div className="modal-takeaways">
              <h3>Key Takeaways</h3>
              <ul>
                {keyTakeaways.map((takeaway, idx) => (
                  <li key={idx}>{takeaway}</li>
                ))}
              </ul>
            </div>
          )}
          
          <div className="modal-actions">
            <ShareButtons title={title} articleId={article.id} />
            <a 
              href={originalUrl}
              target="_blank" 
              rel="noopener noreferrer"
              className="original-link-btn"
            >
              Read Original on {sourceName} →
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArticleModal;